<h1 mat-dialog-title>
    Sei sicuro di voler eliminare questo utente?
</h1>
<div mat-dialog-content>
    <p>
        Username: {{data.username}}
    </p>
</div>
<div mat-dialog-actions>
    <button mat-flat-button color="warn" (click)="onNoClick()">
        ANNULLA
    </button>
    <button mat-flat-button class="daxa" [mat-dialog-close]="true" cdkFocusInitial>
        CONFERMA
    </button>
</div>